import { RouteObject } from 'react-router-dom';
import * as Layout from './Layout';
import { RevenueDeepDive } from './RevenueDeepDive/RevenueDeepDive';
import { SherlockChatActivity } from './SherlockChatActivity/SherlockChatActivity';



export const root: RouteObject = {

  path: 'insights',
  element: (
    <Layout.FC />
  ),
  children: [
    {
      path: '',
      index: true,
      element: <SherlockChatActivity />
    },
    {
      path: ':companyId',
      element: <SherlockChatActivity />
    },
    {
      path: ':companyId/revenueDeepDive',
      element: <RevenueDeepDive />
    }
  ]
};
